import { request } from '@max/meituan-uni-network';
// import { reportBizError } from '../utils/owl';
// eslint-disable-next-line import/no-cycle
import { getQuery } from '../utils/utils';
const API_HOST = {
    TEST: '//top.travel.test.sankuai.com',
    PRODUCTION: '//ihotel.meituan.com'
};
const formatHolidayModelBeforeRender = data => {
    const result = {};
    if (data) {
        data.forEach(item => {
            if (item === null || item === void 0 ? void 0 : item.date) {
                result[item.date] = item;
            }
        });
    }
    return result;
};
/**
 * 获取节假日
 * 接口文档：https://km.sankuai.com/page/1086054189
 * @param params
 * @returns
 */
export const getHolidays = params => {
    const query = getQuery();
    const version_name = query.version_name || '999.9';
    const utm_medium = query.utm_medium || 'mac';
    const queryData = {
        version_name,
        utm_medium,
        biz: 1,
        query: params.query || []
    };
    return request({
        url: `${API_HOST.PRODUCTION}/campaigns/meta/holidays?utm_medium=${utm_medium}&version_name=${version_name}`,
        method: 'POST',
        data: queryData,
        header: {
            'content-type': 'application/json'
        }
    }).then(res => {
        if (!res || !res.data) {
            // reportBizError(queryData, res, 'hbsearch/v4/area/list');
            throw new Error('网络开小差了');
        }
        const data = res.data;
        if (data.resultCode !== 200) {
            // reportBizError(queryData, res, 'hbsearch/v4/area/list');
            throw new Error('网络开小差了');
        }
        return formatHolidayModelBeforeRender(data.data);
    });
};
